import { isNotNullish, isNullish } from '@y42/util/nullish';
import * as go from 'gojs';
import { IS_FAKE_DRAG_CREATE_PORT_PROP } from './../../../../../tools/drag-create-link-tool/config';
import {
  IS_SIDEBAR_TYPE_PROP,
  SIDEBAR_PORT_ID,
  VIRTUAL_SIDEBAR_PORT_ID,
} from './../../common/config/common-prop-names';

let originalFromStroke: go.BrushLike;
let originalToStroke: go.BrushLike;

export const setTemporaryPortStroke = (tool: go.LinkingBaseTool) => {
  if (tool.temporaryFromPort instanceof go.Shape) {
    originalFromStroke = tool.temporaryFromPort.stroke;
    tool.temporaryFromPort.stroke = 'dodgerblue';
  }
  if (tool.temporaryToPort instanceof go.Shape) {
    originalToStroke = tool.temporaryToPort.stroke;
    tool.temporaryToPort.stroke = 'dodgerblue';
  }
};

export const restoreTemporaryPortStroke = (tool: go.LinkingBaseTool) => {
  if (tool.temporaryFromPort instanceof go.Shape && originalFromStroke) {
    tool.temporaryFromPort.stroke = originalFromStroke;
  }
  if (tool.temporaryToPort instanceof go.Shape && originalToStroke) {
    tool.temporaryToPort.stroke = originalToStroke;
  }
};

export const sidebarLinkingToolIsValidTo =
  (tool: go.LinkingTool | go.RelinkingTool) => (toNode: go.Node, __toPort: go.GraphObject) => {
    const sidebarToPort = toNode?.findPort(SIDEBAR_PORT_ID);
    if (isNullish(toNode) || isNullish(sidebarToPort)) {
      return tool.isUnconnectedLinkValid;
    }

    if (tool.diagram.currentTool === tool && isNotNullish(toNode.layer) && !toNode.layer.allowLink) {
      return false;
    }

    if (!!toNode?.data && !toNode?.data[IS_SIDEBAR_TYPE_PROP]) {
      return false;
    }

    return true;
  };

export const sidebarLinkingToolIsValidFrom =
  (tool: go.LinkingTool | go.RelinkingTool) => (fromNode: go.Node, __fromPort: go.GraphObject) => {
    const sidebarFromPort = fromNode?.findPort(SIDEBAR_PORT_ID);
    if (isNullish(fromNode) || isNullish(sidebarFromPort)) {
      return tool.isUnconnectedLinkValid;
    }

    if (tool.diagram.currentTool === tool && isNotNullish(fromNode.layer) && !fromNode.layer.allowLink) {
      return false;
    }

    if (!!fromNode?.data && !fromNode?.data[IS_SIDEBAR_TYPE_PROP] && !fromNode?.data[IS_FAKE_DRAG_CREATE_PORT_PROP]) {
      return false;
    }

    return true;
  };

export const adjustInsertLink = (
  link: go.Link,
  fromNode: go.Node | null,
  fromPort: go.GraphObject | null,
  toNode: go.Node | null,
  toPort: go.GraphObject | null,
) => {
  if (toNode?.data[IS_SIDEBAR_TYPE_PROP] && toPort) {
    link.toPortId = toPort.portId;
  }

  if (!fromNode?.data[IS_SIDEBAR_TYPE_PROP]) {
    return;
  }

  const regxp = new RegExp(`(${VIRTUAL_SIDEBAR_PORT_ID}|${SIDEBAR_PORT_ID})_(top|right|bottom|left)`);
  const match = fromPort?.portId.match(regxp);
  if (fromNode?.data[IS_SIDEBAR_TYPE_PROP] && match?.length === 3) {
    link.fromPortId = `${SIDEBAR_PORT_ID}_${match[2]}`;
  }
};
